<template>
  <div :class="{clickable: clickable}"
       class="card-panel-list-item"
       @click="onWrapperClick">
    <div :class="isMobileClass" class="columns">
      <need-review-circle v-if="needReview"></need-review-circle>
      <div :class="hideOverflowClass" class="column panel-column is-paddingless">
        <div v-if="$slots.title">
          <div class="title"><slot name="title"></slot></div>
        </div>
        <slot name="left-column"></slot>
      </div>
      <div :class="rightColumnClasses" class="column panel-column is-narrow">
        <slot name="right-column"></slot>
      </div>
    </div>
    <slot name="button-bar"></slot>
  </div>
</template>

<script>

import NeedReviewCircle from '../badges/NeedReviewCircle';

export default {
  props: {
    needReview: Boolean,
    hideOverflow: {type: Boolean, default: true},
    mobileColumns: {type: Boolean, default: true},
    clickable: {type: Boolean, default: false}
  },
  computed: {
    hideOverflowClass() {
      return {'hide-overflow': this.hideOverflow};
    },
    isMobileClass() {
      return {'is-mobile': this.mobileColumns};
    },
    rightColumnClasses() {
      return {
        ...this.hideOverflowClass,
        'align-top': this.$slots['button-bar'],
        'align-bottom': !this.$slots['button-bar']
      };
    }
  },
  methods: {
    onWrapperClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    }
  },
  components: {
    NeedReviewCircle
  }
};
</script>

<style lang="scss" scoped>
.card-panel-list-item {
  position: relative;
  padding: 0 20px;

  &.clickable {
    cursor: pointer;

    &:hover .title span:first-child {
      text-decoration: none;
    }

    .title span:first-child {
      text-decoration: underline;
      margin-right: 10px;
    }
  }

  .columns {
    height: auto;
  }

  .column,
  .column div {
    .hide-overflow {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .column:last-child {
    &.align-top {
      align-self: flex-start;
      padding: 5px 0 0;
    }

    &.align-bottom {
      align-self: flex-end;
      padding: 0 0 5px 0;
    }
  }

  .title {
    display: inline-block;
    margin: 0;
  }

  .button-bar {
    padding-top: 5px;
    text-align: right;

    .button {
      width: auto;
    }

    .button:not(:last-child) {
      margin-right: 10px;
    }
  }

  /deep/ .need-review-circle {
    position: absolute;
    left: 6px;
    top: 8px;
  }
}
</style>
